export default __webpack_public_path__ + "static/media/connect_team1.1dd64bb3.svg";